module.exports = __webpack_public_path__ + "static/media/19.32c16b56.jpg";